import { render, staticRenderFns } from "./PanelCompetitionResultsLive.vue?vue&type=template&id=6fb28bc6&scoped=true&"
import script from "./PanelCompetitionResultsLive.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionResultsLive.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionResultsLive.vue?vue&type=style&index=0&id=6fb28bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb28bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb28bc6')) {
      api.createRecord('6fb28bc6', component.options)
    } else {
      api.reload('6fb28bc6', component.options)
    }
    module.hot.accept("./PanelCompetitionResultsLive.vue?vue&type=template&id=6fb28bc6&scoped=true&", function () {
      api.rerender('6fb28bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionResultsLive.vue"
export default component.exports